"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConnectionCookie = exports.decodeConnectionCookie = exports.DEMO_CONNECTION_INDEX = exports.CONNECTION_COOKIE_NAME = void 0;
const getCookieValue_1 = require("./utils/getCookieValue");
const optionalTypeCheck_1 = require("./utils/optionalTypeCheck");
exports.CONNECTION_COOKIE_NAME = 'stardogConnection';
exports.DEMO_CONNECTION_INDEX = 12345;
const decodeConnectionCookie = (rawConnectionCookie) => {
    try {
        const decoded = JSON.parse(atob(rawConnectionCookie));
        const username = decoded.username;
        const endpoint = decoded.endpoint;
        const tokenEndpoint = decoded.tokenEndpoint;
        const graphqlEndpoint = decoded.graphqlEndpoint;
        if (typeof username !== 'string' ||
            typeof endpoint !== 'string' ||
            !(0, optionalTypeCheck_1.optionalTypeCheck)(tokenEndpoint, 'string') ||
            !(0, optionalTypeCheck_1.optionalTypeCheck)(graphqlEndpoint, 'string')) {
            throw new Error('invalid cookie');
        }
        return {
            username,
            endpoint,
            tokenEndpoint,
            graphqlEndpoint,
        };
    }
    catch (_a) {
        return null;
    }
};
exports.decodeConnectionCookie = decodeConnectionCookie;
const getConnectionCookie = () => {
    const rawConnectionCookie = (0, getCookieValue_1.getCookieValue)(exports.CONNECTION_COOKIE_NAME);
    if (!rawConnectionCookie) {
        return null;
    }
    return (0, exports.decodeConnectionCookie)(rawConnectionCookie);
};
exports.getConnectionCookie = getConnectionCookie;
